<template lang="pug">
nav.pagination(v-if="totalPages" > 0, role="navigation", aria-label="Pagination Navigation", :disabled="totalPages == 0")
	a.pagination__btn.pagination__first(v-if="totalPages" > 0,
		href, 
		aria-label="Goto Page 1", 
		:disabled="page == 1 || totalPages == 0",
		@click.prevent="handleNavClick($event, 1)"
	)
	a.pagination__btn.pagination__previous(v-if="totalPages" > 0,
		href, 
		:aria-label="'Goto Previous Page ' + previousPage", 
		:disabled="page == 1 || totalPages == 0",
		@click.prevent="handleNavClick($event, previousPage)"
	)
	.pagination__label
		span.pagination__current(v-if="totalPages" > 0, :aria-label="'Current Page, Page ' + page") {{ page }}
		span.pagination__of &nbsp;of&nbsp; 
		span.pagination__total(:aria-label="'Total page count is ' + totalPages") {{ totalPages }}
	a.pagination__btn.pagination__next(v-if="totalPages" > 0,
		href, 
		:aria-label="'Goto Next Page, ' + nextPage", 
		:disabled="page == totalPages || totalPages == 0",
		@click.prevent="handleNavClick($event, nextPage)"
	)
	a.pagination__btn.pagination__last(v-if="totalPages" > 0,
		href, 
		:aria-label="'Goto Last Page, ' + totalPages", 
		:disabled="page == totalPages || totalPages == 0",
		@click.prevent="handleNavClick($event, totalPages)"
	)
</template>

<script>
export default {
	name: "Pagination",
	props: {
		page: Number,
		total: Number,
		blogsPerPage: Number,
	},
	computed: {
		totalPages() {
			var pagecount = Math.ceil(this.total / this.blogsPerPage);
			if (isNaN(pagecount)) pagecount = 0;
			return pagecount;
		},
		previousPage() {
			return this.page == 1 ? "" : this.page - 1;
		},
		nextPage() {
			return this.page + 1;
		},
	},
	methods: {
		handleNavClick(e, newPage) {
			if (e.target.matches("[disabled]")) return
			this.$emit('navigate', newPage);
		}
	},
}
</script>

<style lang="scss" scoped>

</style>